import { deleteTokenFiles } from '@/helpers';

export default function ({ commit, state }, { token: tokenTodelete }) {
  return deleteTokenFiles(tokenTodelete).then(() => {
    const recordedTokens = state.recordedTokens.filter((t) => t !== tokenTodelete);
    commit('setKey', { key: 'recordedTokens', recordedTokens });
  });
}
